@let control = getControl();

<div class="datepicker-control-wrapper">
  <htx-datepicker-field
    [ctrl]="ctrl()"
    [label]="label() || ''"
    [required]="required()">
  </htx-datepicker-field>

  @if (ctrl().invalid && (ctrl().touched || ctrl().dirty)) {
    <htx-error-field
      [control]="control"
      [errorMessages]="errorMessages()">
    </htx-error-field>
  }
</div>
